import ReactSelect from "react-select";
import { useEffect, useState } from "react";

export const Input = ({ className, ...res }) => {
  return <input className={className} {...res} />;
};
export const InputError = ({ errorTitle, classes }) => {
  return (
    <>
      <div
        className={`flex items-center text-red capitalize sm:text-sm text-base mt-2 ${classes}`}
      >
        <p className="ml-1">* {errorTitle}</p>
      </div>
    </>
  );
};
export const InputWithLabel = ({
  className,
  idFromName,
  label,
  type = "text",
  errors,
  inputClass = "bg-transparent",
  errorsText,
  disabled,
  icon,
  rows,
  maxWords,
  minWords,
  value = "",
  setFieldValue,
  ...res
}) => {
  // count current words
  const wordCount = String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;

  return (
    <div>
      <div
        className={`${className} relative bg-white transition duration-300 rounded`}
      >
        {type === "textarea" ? (
          <textarea
            id={idFromName}
            name={idFromName}
            disabled={disabled}
            rows={rows}
            className={`block px-2.5 pb-2.5 pt-4 w-full text-sm error-forms rounded 
              border-borderTheme/80 appearance-none focus:outline-none focus:ring-0 peer disabled:bg-zinc-300/20 ${inputClass}`}
            placeholder={" "}
            value={value}
            {...res}
          />
        ) : (
          <input
            type={type}
            id={idFromName}
            disabled={disabled}
            name={idFromName}
            className={`block px-2.5 py-2 w-full text-sm error-forms rounded 
              border-borderTheme/80 appearance-none focus:outline-none focus:ring-0 peer disabled:bg-zinc-300/20 ${inputClass}`}
            placeholder={" "}
            value={value}
            {...res}
          />
        )}

        {/* Label with word limit info */}
        <label
          htmlFor={idFromName}
          className={`absolute text-textGrey pointer-events-none text-base bg-white duration-300 transform -translate-y-5 scale-75 top-2 origin-[0] px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 left-1 font-Proxima ${
            rows && rows > 2
              ? "peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-8"
              : "peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2"
          }`}
        >
          {label}
        </label>

        {icon && <>{icon}</>}
      </div>

      {/* Current word count */}
      {maxWords && value && (
        <p
          className={`text-xs mt-1 ${
            wordCount > maxWords ? "text-red" : "text-textGrey"
          }`}
        >
          {wordCount}/{maxWords} words
        </p>
      )}

      {errors ? <InputError errorTitle={errorsText} /> : null}
    </div>
  );
};
export const SelectBox = ({
  options,
  placeholder,
  errors,
  errorsText,
  className,
  paddingY,
  paddingX,
  isDisabled,
  ...res
}) => {
  return (
    <div>
      <ReactSelect
        className={`text-black p-0 sm:text-base text-sm ${className}`}
        placeholder={placeholder}
        options={options}
        isDisabled={isDisabled}
        {...res}
        styles={{
          control: (base) => ({
            ...base,
            border: errors ? "1px solid red" : "1px solid #0000003B",
            borderStyle: isDisabled ? "dashed" : "solid",
            borderColor: isDisabled ? "#D3D3D3" : errors ? "red" : "#0000003B",
            borderRadius: "0.25rem",
            padding: `${paddingY ?? "1px"} ${paddingX ?? "1px"}`,
            boxShadow: "none",
            "&:hover": {
              borderColor: isDisabled ? "#D3D3D3" : "#0000003B",
            },
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#39563E" : "white",
            "&:active": {
              backgroundColor: state.isSelected
                ? "#39563E"
                : "rgba(0, 0, 0, 0.04)",
            },
          }),
        }}
      />
      {errors ? <InputError errorTitle={errorsText} /> : null}
    </div>
  );
};
export const useDebounce = (value, delay = 500) => {
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(() => {
    const handleSearch = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    return () => {
      clearTimeout(handleSearch);
    };
  }, [delay, value]);
  return debounceValue;
};
export const DefaultButton = ({ className, type, disabled, value, ...res }) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className={`${
          disabled
            ? "bg-themeBtn cursor-not-allowed text-dark_secondary_Grey"
            : "bg-themeBtn"
        } text-white flex items-center justify-center px-6 py-2.5 rounded uppercase`}
        type={type ?? "button"}
        disabled={!!disabled}
        {...res}
      >
        <p className="font-figtree text-[15px]">{value}</p>
      </button>
    </div>
  );
};
export const DefaultPrimaryButton = ({
  className,
  type,
  value,
  addclass = "text-themeBtn",
  ...res
}) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className={` border border-themeBtn flex items-center justify-center px-6 py-2.5 rounded uppercase ${addclass}`}
        type={type ?? "button"}
        {...res}
      >
        <p className="font-figtree text-[15px]">{value}</p>
      </button>
    </div>
  );
};
export const Badge = ({ className, value, ...res }) => {
  return (
    <p
      className={`border rounded-full px-2 py-1 text-[12px] font-normal text-center font-figtree  ${className}`}
      {...res}
    >
      {value}
    </p>
  );
};
